import React from 'react';

const images = [
  { name: 'Screenshot' },
  { name: 'Chart Export' },
  { name: 'Logo' },
  { name: 'Slide 01' },
  { name: 'Photo' },
  { name: 'Wireframe' },
];

const ImagePlaceholder: React.FC = () => (
  <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" rx="4" fill="#d1d5db" />
    <path d="M4 18l6-8 4 5 3-3 5 6H4z" fill="#9ca3af" />
    <circle cx="8" cy="8" r="2" fill="#9ca3af" />
  </svg>
);

const Preview: React.FC = () => (
  <div className="h-full bg-surface flex flex-col overflow-hidden">
    {/* Header */}
    <div className="px-3 py-2 border-b bg-neutral-50 flex items-center justify-between gap-2">
      <div className="flex-1">
        <div className="h-5 bg-surface border border-neutral-200 rounded text-[8px] text-neutral-400 px-1.5 flex items-center">
          Search...
        </div>
      </div>
      <div className="text-[8px] text-neutral-500 flex-shrink-0">6 images</div>
      <div className="h-5 px-1.5 bg-primary-600 text-white text-[8px] rounded flex items-center gap-0.5 flex-shrink-0">
        <svg className="w-2.5 h-2.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
        </svg>
        Upload
      </div>
    </div>

    {/* Grid */}
    <div className="flex-1 overflow-hidden p-2">
      <div className="grid grid-cols-3 gap-1.5">
        {images.map(img => (
          <div key={img.name} className="rounded border border-neutral-200 overflow-hidden">
            <div className="w-full aspect-square bg-neutral-100 flex items-center justify-center">
              <ImagePlaceholder />
            </div>
            <div className="px-1.5 py-1 bg-surface">
              <div className="text-[9px] font-medium text-neutral-900 truncate">{img.name}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Preview;
